import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import * as Styled from './edit-page-info-button.styles';

type EditPageInfoButtonProps = { isLabel?: boolean };
export const EditPageInfoButton: FC<EditPageInfoButtonProps> = ({
  isLabel = false,
}) => {
  const { pageContext } = usePageContext();

  const pageSlug = pageContext.pageSlug;
  const editPageInfoLink = `/pages/${pageSlug}/edit/pageInfo`;

  return isLabel ? (
    <Styled.EditLabel
      to={editPageInfoLink}
      size="small"
      data-testid="EDIT_BUTTON_ON_EMPTY_SLOGAN"
    >
      <FormattedMessage id="EP_SLOGAN_EDIT_HINT" />
    </Styled.EditLabel>
  ) : (
    <Styled.EditSloganButton
      size="small"
      showIcon
      data-cy="EDIT_BUTTON_ON_SLOGAN"
      data-testid="EDIT_BUTTON_ON_SLOGAN"
      to={editPageInfoLink}
    />
  );
};
